
export default {
  apps: {
    _tag: 'CSidebarNavItem',
    name: 'ShorexApps',
    phrase: 'shorex-apps',
    to: '/apps',
    icon: ' shorexapps-icon',
   roles: ['Admin','Sub Admin'],
    order:6,
    children: {
      notifications: {
        _tag: 'CSidebarNavItem',
        name: 'notifications',
        phrase: 'nav-notifications',
        to: '/apps/notifications',
        order: 10,
        icon: 'fa-solid fa-bell',
       roles: ['Admin','Sub Admin'],
      },
      products: {
        _tag: 'CSidebarNavItem',
        name: 'products',
        phrase: 'nav-products',
        to: '/apps/products',
        order: 10,
        icon: ' products-icons',
       roles: ['Admin','Sub Admin'],
      },
      promotions: {
        _tag: 'CSidebarNavItem',
        name: 'promotions',
        phrase: 'nav-promotions',
        to: '/apps/promotions',
        order: 10,
        icon: ' promotions-icon',
       roles: ['Admin','Sub Admin'],
      },
      managepolicy: {
        _tag: 'CSidebarNavItem',
        name: 'managepolicy',
        phrase: 'nav-privacy-policy',
        to: '/apps/privacy-policy',
        order: 10,
        icon: ' managepolicy-icon',
       roles: ['Admin','Sub Admin'],
      },
      terms: {
        _tag: 'CSidebarNavItem',
        name: 'terms',
        phrase: 'nav-terms',
        to: '/apps/terms-conditions',
        order: 10,
        icon: 'fa-regular fa-clipboard-list',
       roles: ['Admin','Sub Admin'],
      },
      // managesubAdmin: {
      //   _tag: 'CSidebarNavItem',
      //   name: 'managesubAdmin',
      //   phrase: 'nav-subAdmin-cats',
      //   to: '/apps/subAdmin-categories',
      //   order: 10,
      //   icon: 'fa-regular fa-briefcase',
      //  roles: ['Admin','Sub Admin'],
      // },
      managerewards: {
        _tag: 'CSidebarNavItem',
        name: 'managerewards',
        phrase: 'nav-reward-points',
        to: '/apps/manage-rewards',
        order: 10,
        icon: 'fa-light fa-award fs-4',
       roles: ['Admin','Sub Admin'],
      },
      holidays: {
        _tag: 'CSidebarNavItem',
        name: 'holidays',
        phrase: 'nav-official-holidays',
        to: '/apps/manage-official-holidays',
        order: 10,
        icon: 'holidays-icon',
       roles: ['Admin','Sub Admin'],
      },
      business_category: {
        _tag: 'CSidebarNavItem',
        name: 'business_category',
        phrase: 'shorex:manage-business',
        to: '/apps/business-categories',
        order: 10,
        icon: 'fa-solid fa-suitcase-rolling',
       roles: ['Admin','Sub Admin'],
      },
    },
  },
}
